<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.makePayment.selectCase.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.makePayment.selectCase.subTitle') }}
    </v-card-subtitle>
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th style="width:1px"></th>
            <th v-if="!isSingleCourtMode">{{ $t('page.makePayment.selectCase.court') }}</th>
            <th>{{ $t('courtCase.case') }}</th>
            <th>{{ $t('page.makePayment.selectCase.caseClass') }}</th>
            <th>{{ $t('page.makePayment.selectCase.filedDate') }}</th>
            <th>{{ $t('page.makePayment.selectCase.openClosed') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in bean.caseSearchResults" :key="item.caseInstanceUUID">
            <td style="padding-right:0 !important">
              <v-radio-group v-model="bean.selections.caseInstanceUUID" class="ma-0 pa-0" hide-details>
                <v-radio class="ma-0 pa-0" :value="item.caseInstanceUUID"/>
              </v-radio-group>
            </td>
            <td v-if="!isSingleCourtMode">{{ item.courtName }}</td>
            <td>
              <div style="white-space: nowrap">
                <router-link :to="{ name: 'caseView',
                                    params: { courtID: getCourtByExternalID(item.courtID).resourceID, caseUUID: item.caseInstanceUUID} }">
                  {{ item.caseNumber }}
                </router-link>
              </div>
              <div>
                {{ item.caseTitle }}
              </div>
            </td>
            <td>{{ item.caseClassification }}</td>
            <td>
              <div>
                {{ item.filedDate | formatDate }}
              </div>
              <div>
                {{ item.filedDate | formatTime }}
              </div>
            </td>
            <td>{{ item.closedFlag ? $t('page.makePayment.selectCase.closed') : $t('page.makePayment.selectCase.open') }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-actions class="mt-10 justify-end">
      <c-btn type="primary" @click="save">
        {{ $t('global.continue') }}
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import WorkflowStepMixin from '@/mixins/workflowStep';
import { scrollTo } from '@/application/utility';
import { useApplicationStore } from '@/stores/applicationStore';

const applicationStore = useApplicationStore();

export default {
  mixins: [ WorkflowStepMixin ],
  computed: {
    isSingleCourtMode () {
      return applicationStore.isSingleCourtMode;
    }
  },
  methods: {
    validate () {
      this.$cove.validation.clear();
      if (_.isNil(this.bean.selections.caseInstanceUUID)) {
        this.$cove.validation.addError('caseInstanceUUID', 'page.makePayment.selectCase.validation.selectCase');
      }
      return !this.$cove.validation.hasErrors();
    },
    save () {
      let isValid = this.validate();
      if (!isValid)
      {
        scrollTo(this.CONST.ERROR_CONTAINER_SELECTOR);
      }
      else
      {
        this.$emit('save', this.bean);
      }
    },
    getCourtByExternalID (externalCourtID) {
      return applicationStore.getCourtByExternalID(externalCourtID);
    }
  }
};
</script>
